import React from 'react'

export type ToastMessage = React.ReactNode

export enum ToastType {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
export interface ToastComponentProps {
  message: ToastMessage
  toastType?: ToastType
  position?: ToastPosition
  onClear?: () => void
}

export interface ToastContainerProps {
  position?: ToastPosition
}

export type ToastPosition = 'bottomLeft' | 'topLeft' | 'topRight' | 'bottomRight' | 'none'
